import lotsBasicDataInput from './index.vue'; // 导入组件

lotsBasicDataInput.install = (Vue) => {
    Vue.component(lotsBasicDataInput.name, lotsBasicDataInput);
};
export default lotsBasicDataInput;
